import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { experimentalStyled as styled } from "@mui/material/styles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
  textAlign: "justify",
}));

export default function AccountancyServices() {
  return (
    <div style={{ marginTop: "5%" }}>
      <Box sx={{ flexGrow: 1, width: "65vw", margin: "auto",marginBottom:'2%' }}>
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 3, lg: 3 }}
          columns={{ xs: 4, sm: 4, md: 4, lg: 12 }}
        >
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <img src="accounting.jpg" style={{ width: "100%", borderRadius: '5px' }} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={8}>
            <div style={{color:'gray'}}>
              <h2>Boekhouding</h2>
              <p>
                {" "}
                De basis van een succesvolle onderneming is een nauwkeurige
                bewijskrachtige boekhouding. Dit is niet enkel een wettelijke
                verplichting maar een efficiënte boekhouding zorgt ervoor dat u
                makkelijker en doordachter beslissingen kan nemen voor de groei
                van uw onderneming.
              </p>
              <p>
                Wij helpen u dan ook graag om van uw “papierwinkel” een
                transparante en bruikbare beleidsboekhouding te maken.
              </p>
              <p>
                Hierbij staan wij in voor de volledige verwerking van de
                boekhoudadministratie, het opmaken van tussentijdse resultaten
                en de voorbereiding en afwerking van uw jaarrekening.
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, width: "65vw", margin: "auto" ,marginBottom:'2%' }}>
      <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 3, lg: 3 }}
          columns={{ xs: 4, sm: 4, md: 4, lg: 12 }}
        >
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <img src="fiscal.jpg" style={{ width: "100%" , borderRadius: '5px'}} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={8}>
          <div style={{color:'gray'}}>
              <h2>Fiscaliteit</h2>

              <p>
                Binnen uw onderneming wordt u ook dagelijks geconfronteerd met
                fiscaliteit. Dit kan zowel een vraag zijn rond BTW,
                vennootschapsbelastingen, personenbelastingen,… Het is dan ook
                van het grootste belang dat u deze zaken goed opvolgt.
              </p>
              <p>
                Wij helpen u dan ook graag om de fiscale regelgeving voor uw
                onderneming zo correct mogelijk toe te passen, bij te sturen
                waar nodig en waar het kan deze ook te optimaliseren.
              </p>
              <p>
                Hierbij staan wij in voor het opmaken van de aangiftes BTW,
                personenbelastingen, vennootschapsbelastingen.
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, width: "65vw", margin: "auto",marginBottom:'2%' }}>
      <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 3, lg: 3 }}
          columns={{ xs: 4, sm: 4, md: 4, lg: 12 }}
        >
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <img src="law.jpg" style={{ width: "100%" ,borderRadius: '5px'}} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={8}>
          <div style={{color:'gray'}}>
              <h2>Juridisch</h2>

              <p>
                {" "}
                Het is niet enkel van belang om alles nauwkeurig boekhoudkundig
                en fiscaal te verwerken maar daarnaast dient u als onderneming
                ook regelmatig uw financiële planning op te maken en/of bij te
                sturen. Dit in het kader van een mogeljjke uitbreiding of
                investering binnen uw onderneming.
              </p>
              <p>
                {" "}
                Bij een dergelijke uitbreiding of investering binnen uw
                onderneming komen vaak ook contracten, aktes en diverse
                overeenkomsten kijken.
              </p>
              <p>
                {" "}
                Wij helpen u dan ook graag bij uw persoonlijke financiële planning,
                het opmaken van contracten, het aanmaken van aktes en
                overeenkomsten. Dit waar nodig in een samenwerking met de
                notaris, bedrijfsrevisor of eventuele jurist.
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, width: "65vw", margin: "auto" ,marginBottom:'2%' }}>
      <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 3, lg: 3 }}
          columns={{ xs: 4, sm: 4, md: 4, lg: 12 }}
        >
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <img src="startup.jpg" style={{ width: "100%" , borderRadius: '5px'}} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={8}>
          <div style={{color:'gray'}}>
              <h2>Startersbegeleiding</h2>
              <p>
                {" "}
                U hebt een fantastisch idee om een zaak op te starten. Maar na
                de eerste opwelling komen voor u als toekomstig ondernemer ook
                al de eerste vragen : kan ik deze activiteit uitoefenen, is er
                een markt voor, heb ik extra financiële middelen nodig via de
                bank of andere kanalen, welke wettelijke formaliteiten moet ik
                naleven ?
              </p>{" "}
              <p>
                Wij helpen u hierbij graag verder in de begeleiding van uw
                eerste stappen als ondernemer
              </p>{" "}
              <p>
                Zo zorgen wij voor een correct en haalbaar financieel plan,
                verzorgen wij voor u de nodige opstartformaliteiten.
              </p>
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
